import { ReactNode } from 'react';

import { useCharityStyle } from '../../../Shared/useCharityStyle';
import { SharedProps } from '../../types';
import Container from '../../UI/Container';
import Layout from '../../UI/Layout';
import EditCustomMailForm, { EditCustomMailFormProps } from './EditCustomMailForm';
import { ProjectLayout } from './ProjectLayout';

export interface EditCustomMailPageProps extends SharedProps {
  mail: EditCustomMailFormProps['mail'];
  project: EditCustomMailFormProps['project'];
  products: EditCustomMailFormProps['products'];
  charity: EditCustomMailFormProps['charity'];
}

export default function EditCustomMailPage({
  mail,
  project,
  products,
  charity,
  auth: { user },
}: EditCustomMailPageProps) {
  useCharityStyle(charity);

  return (
    <Container className="space-y-6">
      <EditCustomMailForm
        mail={mail}
        project={project}
        products={products}
        charity={charity}
        user={user}
      />
    </Container>
  );
}

EditCustomMailPage.layout = (page: ReactNode) => <Layout><ProjectLayout>{page}</ProjectLayout></Layout>;
